<breadcrumb endText="System Branding" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="font-medium text-xl mb-2">
    System Branding
  </div>
  <hr />
  <div class="mt-5">
    <div class="grid grid-cols-2 w-fit gap-2">
      Primary Color:
      <!-- TODO design the color picker -->
      <input type="color" class="w-full" [(ngModel)]="primaryColor"/>
      Banner Image URL:
      <input type="url" class="input" [(ngModel)]="bannerUrl"/>
      Login Logo Image URL:
      <input type="url" class="input" [(ngModel)]="loginLogoUrl"/>
      Login Background Image URL:
      <input type="url" class="input" [(ngModel)]="loginBackgroundUrl"/>
    </div>
  </div>
  <div class="flex justify-end">
    <outline-button [marginRight]="true" (click)="systemManagementMenu()" text="Cancel" />
    <full-button (click)="saveBranding()" text="Save" />
  </div>
</div>
